import { Theme, alpha } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN } from '../../theme';

const useStyles = (background, isSingleQuoteBlock) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        zIndex: 1,
        position: 'relative',
        paddingTop: MIDDLE_MARGIN,
        paddingBottom: MIDDLE_MARGIN,
        background: theme.palette.secondary.dark,
        '& .swiper-wrapper': {
          alignItems: 'center',
        },
        [theme.breakpoints.up('md')]: {
          paddingTop: isSingleQuoteBlock ? 108 : LARGE_MARGIN,
          paddingBottom: isSingleQuoteBlock ? 108 : LARGE_MARGIN,
          backgroundColor:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },
        [theme.breakpoints.down('md')]: {
          '& .swiper-button-prev::after, & .swiper-button-next::after': {
            width: 12,
            height: 24,
            fontSize: 24,
          },
          '& .swiper-button-prev, & .swiper-button-next': {
            width: 30,
            height: 86,
            display: 'flex',
          },
        },
        [theme.breakpoints.down('sm')]: {
          '& .swiper-button-prev::after, & .swiper-button-next::after': {
            width: 9,
            height: 16,
            fontSize: 16,
          },
        },
      },
      imageWrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        zIndex: -1,
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
          background: alpha(colorsPalette.blueDark, 0.33),
        },
      },
      imageLazyloadWrapper: {
        width: '100%',
        height: '100%',
      },
      image: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      singleContainer: {
        maxWidth: 800,
      },
    }),
  );

export default useStyles;
